import { FC, useEffect, useState } from 'react';
import { ModalCustomerDetails } from '~/components';
import { isEmpty, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { showAlert, useStores } from '~/utils';
import CustomerAccounts from './CustomerAccounts';

const CustomerAccountsContainer: FC = () => {
  const navigate = useNavigate();

  const {
    customers: {
      currentCustomer,
      customerAccounts,
      getCustomerById,
      getCustomerAccounts,
    },
  } = useStores();

  const [isAccountsLoading, setIsAccountsLoading] = useState(true);
  const [isModalCustomerDetailsOpen, setIsModalCustomerDetailsOpen] =
    useState(false);

  const onPressAccount = (account: CustomerAccount) => {
    // TODO: Navigate to customer account details when implemented
    console.log('Customer account selected:', account);
  };

  const handleModalCustomerDetails = () => {
    setIsModalCustomerDetailsOpen((value) => !value);
  };

  const loadCustomerData = async () => {
    if (isEmpty(currentCustomer) || !currentCustomer.id) {
      navigate(Routes.CUSTOMERS);
      return;
    }

    setIsAccountsLoading(true);
    try {
      await Promise.all([
        getCustomerById(currentCustomer.id),
        getCustomerAccounts(currentCustomer.id),
      ]);
    } catch ({ message }) {
      showAlert({ message });
    } finally {
      setIsAccountsLoading(false);
    }
  };

  useEffect(() => {
    loadCustomerData();
  }, []);

  useEffect(() => {
    if (isEmpty(currentCustomer)) {
      navigate(Routes.CUSTOMERS);
    }
  }, [currentCustomer]);

  return (
    <>
      <CustomerAccounts
        customer={currentCustomer}
        customerAccounts={customerAccounts}
        isAccountsLoading={isAccountsLoading}
        onPressAccount={onPressAccount}
        onShowCustomerData={handleModalCustomerDetails}
      />
      <ModalCustomerDetails
        customer={currentCustomer}
        isOpen={isModalCustomerDetailsOpen}
        handleClose={handleModalCustomerDetails}
      />
    </>
  );
};

export default observer(CustomerAccountsContainer);
